// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"0d712bb7","205":"83c5e801","435":"38968abc"}[chunkId] + ".chunk.js";
};